export default class DependencyResolver {
  /**
   * @throws Exception\ResolveException
   */
  static resolve(items) {
    let resolved = []
    let unresolved = []
    let returnImmediately = false

    // Resolve dependencies for each table
    const keys = Object.keys(items)
    for (var i = 0; i < keys.length; i++) {
      // console.log("keys[i]", keys[i]);
      ;[resolved, unresolved, returnImmediately] = this.resolver(
        keys[i],
        items,
        resolved,
        unresolved,
      )
      // console.log("destructured", [resolved, unresolved, returnImmediately]);
      if (returnImmediately) {
        return resolved
      }
    }

    return resolved
  }

  /**
   * @param int|string $item
   *
   * @throws Error
   */
  static resolver(key, items, resolved, unresolved) {
    let returnImmediately = false

    unresolved.push(key)

    // console.log(`items[${key}]`, items[key]) ;
    for (var i = 0; i < items[key].length; i++) {
      const dep = items[key][i]

      // console.log("  dep for ", key, "=", dep)
      if (!items[dep]) {
        throw new Error("Missing reference " + dep + " for " + key)
        // return [resolved, unresolved, true];
      }

      if (resolved.indexOf(dep) >= 0) {
        continue
      }

      if (unresolved.indexOf(dep) >= 0) {
        throw new Error("Circular reference " + dep + " for " + key)
        // return [resolved, unresolved, true];
      }

      unresolved.push(dep)
      ;[resolved, unresolved, returnImmediately] = this.resolver(
        dep,
        items,
        resolved,
        unresolved,
      )
      // console.log("destructured", [resolved, unresolved, returnImmediately]);

      if (returnImmediately) {
        return [resolved, unresolved, returnImmediately]
      }
    }

    // Add key to resolved if it's not already there
    if (resolved.indexOf(key) < 0) {
      resolved.push(key)
    }

    // Remove all occurrences of key in unresolved
    let index
    while ((index = unresolved.indexOf(key)) >= 0) {
      delete unresolved[index]
    }

    return [resolved, unresolved, false]
  }
}
